// Alle Inhalte hier zentral bearbeitbar.
const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1600&q=75`;

export const IMAGES = {
  hero: u("photo-1785649909681-e895dcb0f54e"),
  beet: u("photo-1597201278257-3687be27d954"),
  hecke: u("photo-1706920925080-be07c32398e1"),
  rasen: u("photo-1689728222087-6984f72460c4"),
  about: u("photo-1605117882932-f9e32b03fea9"),
  jonas: "/brand/jonas-feierstein.jpg",
  before: u("photo-1785526829686-5fe5447d871c"),
  after: u("photo-1773244398609-a4085e26b7c6"),
};

export const CONTACT = {
  email: "gruenwirbel@gmail.com",
  phone: "017670718231",
  whatsapp: "4917670718231",
  hours: "Mo–Fr 8–18 Uhr\nSa 9–14 Uhr",
  // Wochentag (1 = Mo … 6 = Sa) → [von, bis] in Stunden, deutsche Zeit
  schedule: { 1: [8, 18], 2: [8, 18], 3: [8, 18], 4: [8, 18], 5: [8, 18], 6: [9, 14] },
  area: "Herxheim und Umgebung",
  owner: "Jonas Feierstein",
};

export const NAV = [
  { id: "leistungen", label: "Leistungen" },
  { id: "ueber", label: "Über uns" },
  { id: "ablauf", label: "Ablauf" },
  { id: "einzugsgebiet", label: "Einzugsgebiet" },
  { id: "kontakt", label: "Kontakt" },
];

export const SERVICES = [
  {
    key: "rasenpflege",
    title: "Rasenpflege",
    text: "Mähen, Kanten schneiden und ein Rasen, der wieder gleichmäßig und gepflegt aussieht.",
    note: "",
    image: "rasen",
  },
  {
    key: "hecken",
    title: "Hecken- und Strauchschnitt",
    text: "Sauberer Form- und Rückschnitt, damit Hecken und Sträucher in Form bleiben.",
    note: "",
    image: "hecke",
  },
  {
    key: "beetpflege",
    title: "Beetpflege",
    text: "Unkraut entfernen, Beete auflockern und ordentlich halten.",
    note: "",
    image: "beet",
  },
  {
    key: "saisonal",
    title: "Saisonale Gartenarbeiten",
    text: "Arbeiten, die im Frühjahr, Sommer oder Herbst anfallen – passend zur Jahreszeit.",
    note: "",
    icon: "Leaf",
  },
  {
    key: "allgemein",
    title: "Allgemeine Gartenpflege",
    text: "Regelmäßige Pflege oder einmalige Unterstützung – wir stimmen gemeinsam ab, was Ihr Garten braucht.",
    note: "",
    icon: "Shovel",
  },
];

export const PLANS = [
  { key: "abo-2", hours: 2, price: 79 },
  { key: "abo-4", hours: 4, price: 149 },
  { key: "abo-6", hours: 6, price: 210 },
];
export const planLabel = (p) => `Abo: ${p.hours} Stunden monatlich (${p.price} €)`;
export const PRICE_NOTE = "Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.";

// Grobe Richtwerte in Stunden pro Monat – hier anpassen.
export const CALC_SIZES = [
  { key: "klein", label: "Klein", hint: "bis ca. 200 m²" },
  { key: "mittel", label: "Mittel", hint: "ca. 200–500 m²" },
  { key: "gross", label: "Groß", hint: "über 500 m²" },
];
export const CALC_TASKS = [
  { key: "rasen", label: "Rasenpflege", hours: { klein: 0.75, mittel: 1.25, gross: 2 } },
  { key: "hecke", label: "Hecken- und Strauchschnitt", hours: { klein: 0.5, mittel: 1, gross: 1.5 } },
  { key: "beet", label: "Beetpflege", hours: { klein: 0.5, mittel: 1, gross: 1.5 } },
  { key: "saison", label: "Saisonale Gartenarbeiten", hours: { klein: 0.25, mittel: 0.5, gross: 1 } },
];

export const WHATSAPP_TEXT = "Hallo Jonas, ich interessiere mich für eine Gartenpflege. Ich schicke dir ein paar Fotos von meinem Garten.";

export const STEPS = [
  { n: "01", title: "Anfrage", text: "Sie schreiben uns kurz, worum es geht – per Formular oder E-Mail." },
  { n: "02", title: "Besichtigung & Abstimmung", text: "Wir schauen uns den Garten an oder klären die Details gemeinsam ab." },
  { n: "03", title: "Gartenarbeit", text: "Wir erledigen die vereinbarten Arbeiten sorgfältig und hinterlassen alles ordentlich." },
];

export const MARQUEE = ["Rasenpflege", "Heckenschnitt", "Strauchschnitt", "Beetpflege", "Saisonale Gartenarbeiten", "Gartenpflege"];
